import React, { useEffect, useState } from "react";
import { adminApi, catalogApi } from "../../api/client";

export default function Settings() {
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [newCategoryName, setNewCategoryName] = useState("");
  const [newSubcategoryName, setNewSubcategoryName] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState("");

  // Add this state to store all subcategories combined
// const [allSubcategories, setAllSubcategories] = useState([]);

// Load all subcategories whenever categories change
// useEffect(() => {
//   const fetchAllSubs = async () => {
//     try {
//       let combinedSubs = [];
//       for (let cat of categories) {
//         const subs = await catalogApi.listSubcategories(cat._id);
//         combinedSubs = [...combinedSubs, ...(subs?.items || [])];
//       }
//       setAllSubcategories(combinedSubs);
//     } catch {
//       setAllSubcategories([]);
//     }
//   };

//   if (categories.length) fetchAllSubs();
// }, [categories]);

  // Load categories on mount
  useEffect(() => {
    (async () => {
      try {
        const cat = await catalogApi.listCategories();
        setCategories(cat?.items || []);
      } catch {
        setCategories([]);
      }
    })();
  }, []);

  const handleCategoryChange = async (e) => {
    const id = e.target.value;
    setSelectedCategoryId(id);
    if (id) {
      try {
        const subs = await catalogApi.listSubcategories(id);
        setSubcategories(subs?.items || []);
      } catch {
        setSubcategories([]);
      }
    } else {
      setSubcategories([]);
    }
  };

  const addCategory = async () => {
    if (!newCategoryName.trim()) return;
    try {
      await adminApi.createCategory({ name: newCategoryName.trim() });
      const cat = await catalogApi.listCategories();
      setCategories(cat?.items || []);
      setNewCategoryName("");
    } catch {
      alert("Failed to create category");
    }
  };

  const addSubcategory = async () => {
    if (!selectedCategoryId || !newSubcategoryName.trim()) return;
    try {
      await adminApi.createSubcategory(selectedCategoryId, {
        name: newSubcategoryName.trim(),
      });
      const subs = await catalogApi.listSubcategories(selectedCategoryId);
      setSubcategories(subs?.items || []);
      setNewSubcategoryName("");
    } catch {
      alert("Failed to create subcategory");
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">
        Settings
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Add Category */}
        <div className="bg-white p-4 shadow rounded">
          <h3 className="font-semibold mb-3">Add Category</h3>
          <input
            type="text"
            placeholder="Category Name"
            value={newCategoryName}
            onChange={(e) => setNewCategoryName(e.target.value)}
            className="border p-2 w-full mb-3 rounded"
          />
          <button
            onClick={addCategory}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
          >
            Save
          </button>
          <ul className="mt-4 space-y-1 grid grid-cols-2 text-sm text-gray-700">
            {categories.map((cat, i) => (
              <li key={cat._id}>
                {i + 1}. {cat.name}
              </li>
            ))}
          </ul>
        </div>

        {/* Add Subcategory */}
        <div className="bg-white p-4 shadow rounded">
          <h3 className="font-semibold mb-3">Add Subcategory</h3>
          <select
            className="border p-2 w-full mb-3 rounded"
            value={selectedCategoryId}
            onChange={handleCategoryChange}
          >
            <option value="">Select Category</option>
            {categories.map((c) => (
              <option key={c._id} value={c._id}>
                {c.name}
              </option>
            ))}
          </select>
          <input
            type="text"
            placeholder="Subcategory Name"
            value={newSubcategoryName}
            onChange={(e) => setNewSubcategoryName(e.target.value)}
            className="border p-2 w-full mb-3 rounded"
          />
          <button
            onClick={addSubcategory}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
          >
            Save
          </button>
          <ul className="mt-4 space-y-1 grid grid-cols-2 text-sm text-gray-700">
            {subcategories.map((sub, i) => (
              <li key={sub._id}>
                {i + 1}. {sub.name}
              </li>
            ))}
          </ul>
        </div>
      </div>
      {/* <ul className="mt-4 space-y-1 grid grid-cols-2 text-sm text-gray-700">
        <h4 className="col-span-2 font-semibold">All Subcategories</h4>
        {allSubcategories.map((sub, i) => (
          <li key={sub._id}>
            {i + 1}. {sub.name}
          </li>
        ))}
      </ul> */}
    </div>
  );
}
